<template>
  <div
    class="row"
    v-if="borrow"
  >
    <div class="col-md-3">
      <div class="row">
        <div class="col-md-12">
          <upload-photo :borrow="borrow" />
        </div>
        <div class="col-md-12">
          <upload-national-id-card :borrow="borrow" />
        </div>
      </div>
    </div>
    <div class="col-md-9">
      <!--client edit-->
      <div
        class="box box-primary"
        v-if="isClientForm"
      >
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('string.loanType') }}
          </h3>
        </div>
        <div class="box-body">
          <div class="row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['loan_type']}"
            >
              <label class="required">{{ $t('fields.loanType') }}</label>
              <div class="input-group">
                <select
                  class="form-control"
                  :disabled="true"
                  v-model="borrow.type"
                >
                  <option value="Payday">
                    {{ $t('label.payday') }}
                  </option>
                  <option value="Personal">
                    {{ $t('label.personal') }}
                  </option>
                  <option value="Purchasing">
                    {{ $t('label.installment') }}
                  </option>
                  <option value="Pawn">
                    {{ $t('label.pawn') }}
                  </option>
                </select>
                <span
                  class="input-group-addon cursor-pointer"
                  data-toggle="modal"
                  @click="changeBorrowType"
                  data-target="#changeBorrowType"
                >{{ $t('button.change') }}</span>
              </div>
              <template v-if="validations['loan_type']">
                <span class="label-error">
                  {{ validations['loan_type'][0] }}
                </span>
              </template>
            </div>
            <template v-if="!loan">
              <div
                class="col-md-6 form-group"
                :class="{'has-error' : validations['loan_type']}"
              >
                <label class="required">{{ $t('fields.loanPurpose') }}</label>
                <select
                  class="form-control"
                  :disabled="disabledInputLoanSection"
                  v-model="borrow.loan_type"
                >
                  <template v-if="loanTypes && Array.isArray(loanTypes) && loanTypes.length > 0">
                    <optgroup
                      :label="loanType.name"
                      :key="loanTypeIndex"
                      v-for="(loanType, loanTypeIndex) in loanTypes"
                    >
                      <template v-for="(cLoanType, cIndex) in loanType.children">
                        <option
                          :value="cLoanType"
                          :key="cIndex"
                        >
                          {{ cLoanType.name }}
                        </option>
                      </template>
                    </optgroup>
                  </template>
                </select>
                <span
                  class="label-error"
                  v-if="validations['loan_type']"
                >
                  {{ validations['loan_type'][0] }}
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!--loan information-->
      <div
        class="box box-primary"
        v-if="loan"
      >
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('labels.loanInformation') }}
          </h3>
        </div>
        <div class="box-body">
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['amount']}"
            >
              <label class="required">{{ $t('fields.amount') }}</label>
              <input
                type="number"
                :disabled="disabledInputLoanSection"
                v-model="loan.amount"
                :placeholder="$t('fields.amount')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['amount']"
              >
                {{ validations['amount'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['duration']}"
            >
              <label class="required">{{ $t('fields.duration') }}</label>
              <input
                type="number"
                :disabled="disabledInputLoanSection"
                v-model="loan.duration"
                :placeholder="$t('fields.duration')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['duration']"
              >
                {{ validations['duration'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['type']}"
            >
              <label class="required">{{ $t('fields.loanType') }}</label>
              <div class="input-group">
                <select
                  class="form-control"
                  :disabled="true"
                  v-model="loan.loan_type"
                >
                  <option value="Payday">
                    {{ $t('label.payday') }}
                  </option>
                  <option value="Personal">
                    {{ $t('label.personal') }}
                  </option>
                  <option value="Purchasing">
                    {{ $t('label.installment') }}
                  </option>
                  <option value="Pawn">
                    {{ $t('label.pawn') }}
                  </option>
                </select>
                <span
                  class="input-group-addon cursor-pointer"
                  data-toggle="modal"
                  @click="changeBorrowType"
                  data-target="#changeBorrowType"
                >{{ $t('button.change') }}</span>
              </div>
              <span
                class="label-error"
                v-if="validations['type']"
              >
                {{ validations['type'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['loan_type']}"
            >
              <label class="required">{{ $t('fields.loanPurpose') }}</label>
              <select
                class="form-control"
                :disabled="disabledInputLoanSection"
                v-model="loan.purpose_loan"
              >
                <template v-if="loanTypes && Array.isArray(loanTypes) && loanTypes.length > 0">
                  <optgroup
                    :label="loanType.name"
                    :key="loanTypeIndex"
                    v-for="(loanType, loanTypeIndex) in loanTypes"
                  >
                    <template v-for="(cLoanType, cIndex) in loanType.children">
                      <option
                        :value="cLoanType"
                        :key="cIndex"
                      >
                        {{ cLoanType.name }}
                      </option>
                    </template>
                  </optgroup>
                </template>
              </select>
              <span
                class="label-error"
                v-if="validations['loan_type']"
              >
                {{ validations['loan_type'][0] }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--borrower information-->
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('labels.borrowerInformation') }}
          </h3>
        </div>
        <div class="box-body">
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['name']}"
            >
              <label
                class="required"
                for="firstName"
              >{{ $t('fields.firstName') }}</label>
              <input
                type="text"
                id="firstName"
                :disabled="disabled"
                v-model="borrow.name"
                :placeholder="$t('fields.firstName')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['name']"
              >
                {{ validations['name'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['last_name']}"
            >
              <label
                class="required"
                for="lastName"
              >{{ $t('fields.lastName') }}</label>
              <input
                type="text"
                id="lastName"
                v-model="borrow.last_name"
                :disabled="disabled"
                :placeholder="$t('fields.lastName')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['last_name']"
              >
                {{ validations['last_name'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['phone']}"
            >
              <label
                class="required"
                for="phone"
              >{{ $t('fields.phone') }}</label>
              <input
                type="text"
                id="phone"
                :disabled="disabled"
                v-model="borrow.phone"
                :placeholder="$t('fields.phone')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['phone']"
              >
                {{ validations['phone'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['email']}"
            >
              <label
                class="required"
                for="email"
              >{{ $t('fields.email') }}</label>
              <input
                type="text"
                id="email"
                :disabled="disabled"
                v-model="borrow.email"
                :placeholder="$t('fields.email')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['email']"
              >
                {{ validations['email'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['national_id_number']}"
            >
              <label
                class="required"
                for="national_id_number"
              >{{ $t('fields.nationalIdNumber') }}</label>
              <input
                type="text"
                id="national_id_number"
                :disabled="disabled"
                v-model="borrow.national_id_number"
                :placeholder="$t('fields.nationalIdNumber')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['national_id_number']"
              >
                {{ validations['national_id_number'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['date_of_birth']}"
            >
              <label
                class="required"
                for="date_of_birth"
              >{{ $t('fields.dateOfBirth') }}</label>
              <input
                type="text"
                id="date_of_birth"
                :disabled="disabled"
                v-model="borrow.date_of_birth"
                :placeholder="$t('string.dateOfBirth')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['date_of_birth']"
              >
                {{ validations['date_of_birth'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['gender']}"
            >
              <label
                class="required"
                for="gender"
              >{{ $t('fields.gender') }}</label>
              <select
                class="form-control"
                :disabled="disabled"
                id="gender"
                v-model="borrow.gender"
              >
                <option
                  :value="null"
                  selected
                  disabled
                >
                  {{ $t('fields.gender') }}
                </option>
                <option
                  v-for="(gender, key) in genders"
                  :key="key"
                  :value="gender.value"
                >
                  {{ gender.label }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations['gender']"
              >
                {{ validations['gender'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['marital_status']}"
            >
              <label
                class="required"
                for="marital_status"
              >{{ $t('fields.maritalStatus') }}</label>
              <select
                class="form-control"
                :disabled="disabled"
                id="marital_status"
                v-model="borrow.marital_status"
              >
                <option
                  :value="null"
                  selected
                  disabled
                >
                  {{ $t('fields.maritalStatus') }}
                </option>
                <option
                  v-for="(marital_status, key) in maritalStatuses"
                  :key="key"
                  :value="marital_status.value"
                >
                  {{ marital_status.label }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations['marital_status']"
              >
                {{ validations['marital_status'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['home_number']}"
            >
              <label
                class=""
                for="home_number"
              >{{ $t('fields.homeNumber') }}</label>
              <input
                class="form-control"
                :disabled="disabled"
                id="home_number"
                v-model="borrow.home_number"
                :placeholder="$t('fields.homeNumber')"
              >
              <span
                class="label-error"
                v-if="validations['home_number']"
              >
                {{ validations['home_number'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['street_number']}"
            >
              <label
                class=""
                for="street_number"
              >{{ $t('fields.streetNumber') }}</label>
              <input
                class="form-control"
                :disabled="disabled"
                id="street_number"
                v-model="borrow.street_number"
                :placeholder="$t('fields.streetNumber')"
              >
              <span
                class="label-error"
                v-if="validations['street_number']"
              >
                {{ validations['street_number'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['province']}"
            >
              <label
                class="required"
                for="province"
              >{{ $t('fields.province') }}</label>
              <select
                class="form-control"
                :disabled="disabled"
                id="province"
                @change="getProvinces"
                v-model="borrow.province"
              >
                <option
                  :value="null"
                  selected
                  disabled
                >
                  {{ $t('fields.province') }}
                </option>
                <option
                  v-for="(province, key) in provinces"
                  :key="key"
                  :value="province['name_latin']"
                >
                  {{ $i18n.locale === 'km' ? province['name_km'] : province['name_latin'] }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations['province']"
              >
                {{ validations['province'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['district']}"
            >
              <label
                class="required"
                for="district"
              >{{ $t('fields.district') }}</label>
              <select
                class="form-control"
                :disabled="disabled"
                id="district"
                @change="getCommunes"
                v-model="borrow.district"
              >
                <option
                  :value="null"
                  selected
                  disabled
                >
                  {{ $t('fields.district') }}
                </option>
                <option
                  v-for="(district, key) in districts"
                  :key="key"
                  :value="district['name_latin']"
                >
                  {{ $i18n.locale === 'km' ? district['name_km'] : district['name_latin'] }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations['district']"
              >
                {{ validations['district'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['commune']}"
            >
              <label
                class="required"
                for="commune"
              >{{ $t('fields.commune') }}</label>
              <select
                class="form-control"
                :disabled="disabled"
                id="commune"
                v-model="borrow.commune"
              >
                <option
                  :value="null"
                  selected
                  disabled
                >
                  {{ $t('fields.commune') }}
                </option>
                <option
                  v-for="(commune, key) in communes"
                  :key="key"
                  :value="commune['name_latin']"
                >
                  {{ $i18n.locale === 'km' ? commune['name_km'] : commune['name_latin'] }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations['commune']"
              >
                {{ validations['commune'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['home_type']}"
            >
              <label
                for="borrower_status"
                class="required"
              >{{ $t('fields.label.home_type') }}</label>
              <select
                class="form-control"
                :disabled="disabled"
                id="borrower_status"
                v-model="borrow.home_type"
              >
                <option
                  value="null"
                  selected
                  disabled
                >
                  {{ $t('fields.pla.choose_a_home_type') }}
                </option>
                <template v-if="homeTypes && Array.isArray(homeTypes) && homeTypes.length > 0">
                  <option
                    v-for="(homeType, key) in homeTypes"
                    :key="key"
                    :value="homeType.value"
                  >
                    {{ homeType['name_' + $i18n.locale] }}
                  </option>
                </template>
              </select>
              <span
                class="label-error"
                v-if="validations['home_type']"
              >
                {{ validations['home_type'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['how_long_have_been_living_there']}"
            >
              <label
                class="required"
                for="how_long_have_been_living_there"
              >{{ $t('fields.howLongHaveBeenLivingThere') }}?</label>
              <select
                class="form-control"
                id="how_long_have_been_living_there"
                :disabled="disabled"
                v-model="borrow.how_long_have_been_living_there"
              >
                <option
                  selected
                  disabled
                  :value="null"
                >
                  {{ $t('fields.howLongHaveBeenLivingThere') }}
                </option>
                <option
                  v-for="(living, key) in livings"
                  :key="key"
                  :value="living.value"
                >
                  {{ living.label }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations['how_long_have_been_living_there']"
              >
                {{ validations['how_long_have_been_living_there'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['borrow_education']}"
            >
              <label
                class="required"
                for="borrow_education"
              >{{ $t('fields.borrowEducation') }}</label>
              <select
                class="form-control"
                id="borrow_education"
                :disabled="disabled"
                v-model="borrow.borrow_education"
              >
                <option
                  selected
                  disabled
                  :value="null"
                >
                  {{ $t('fields.borrowEducation') }}
                </option>
                <template v-if="educations && Array.isArray(educations) && educations.length > 0">
                  <option
                    :value="education"
                    :key="eIndex"
                    v-for="(education, eIndex) in educations"
                  >
                    {{ $i18n.locale === 'km' ? education['name_kh'] : education.name }}
                  </option>
                </template>
              </select>
              <span
                class="label-error"
                v-if="validations['borrow_education']"
              >
                {{ validations['borrow_education'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['school_name']}"
            >
              <label
                class=""
                for="school_name"
              >{{ $t('fields.schoolName') }}</label>
              <input
                type="text"
                id="school_name"
                :disabled="disabled"
                v-model="borrow.school_name"
                :placeholder="$t('fields.schoolName')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['school_name']"
              >
                {{ validations['school_name'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['graduate_year']}"
            >
              <label
                for="graduate_year"
              >{{ $t('fields.graduateYear') }}</label>
              <select
                class="form-control"
                id="graduate_year"
                :disabled="disabled"
                v-model="borrow.graduate_year"
              >
                <option
                  selected
                  disabled
                  :value="null"
                >
                  {{ $t('fields.graduateYear') }}
                </option>
                <option
                  v-for="(year, key) in graduateYears"
                  :key="key"
                  :value="year"
                >
                  {{ year }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations['graduate_year']"
              >
                {{ validations['graduate_year'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['study_major']}"
            >
              <label
                class=""
                for="study_major"
              >{{ $t('fields.studyMajor') }}</label>
              <select
                class="form-control"
                id="study_major"
                :disabled="disabled"
                v-model="borrow.study_major"
              >
                <option
                  selected
                  disabled
                  :value="null"
                >
                  {{ $t('fields.studyMajor') }}
                </option>
                <option
                  v-for="(major, key) in majors"
                  :key="key"
                  :value="major.value"
                >
                  {{ major.label }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations['study_major']"
              >
                {{ validations['study_major'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['source_of_information']}"
            >
              <label
                class="required"
                for="howDidYouHearAboutUs"
              >{{ $t('fields.howDidYouHearAboutUs?') }}</label>
              <select
                v-model="borrow.source_of_information"
                id="howDidYouHearAboutUs"
                :disabled="disabled"
                class="form-control"
              >
                <option
                  selected
                  disabled
                  :value="null"
                >
                  {{ $t('fields.howDidYouHearAboutUs?') }}
                </option>
                <option
                  v-for="(source, key) in sourceInformation"
                  :key="key"
                  :placeholder="$t('fields.howDidYouHearAboutUs?')"
                  :value="source.value"
                >
                  {{ source.label }}
                </option>
              </select>
              <template v-if="borrow.source_of_information === 'Other'">
                <div class="margin-bottom" />
                <input
                  type="text"
                  :disabled="disabled"
                  v-model="borrow.source_of_information_other"
                  :placeholder="$t('fields.howDidYouHearAboutUs?')"
                  class="form-control"
                >
              </template>
              <span
                class="label-error"
                v-if="validations['source_of_information']"
              >
                {{ validations['source_of_information'][0] }}
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label for="membership">{{ $t('fields.membership') }}</label>
              <select
                class="form-control"
                :disabled="disabled"
                id="membership"
                v-model="borrow.membership"
              >
                <option
                  :value="null"
                  selected
                  disabled
                >
                  {{ $t('string.chooseMembership') }}
                </option>
                <template v-if="memberships && Array.isArray(memberships) && memberships.length">
                  <option
                    v-for="(item, key) in memberships"
                    :key="key"
                    :value="item"
                  >
                    {{ item['name_' + $i18n.locale] }}
                  </option>
                </template>
              </select>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['borrower_status']}"
            >
              <label
                for="borrower_status"
                class="required"
              >{{ $t('fields.borrower_status') }}</label>
              <select
                class="form-control"
                :disabled="disabled"
                id="borrower_status"
                v-model="borrow.borrower_status"
              >
                <option
                  :value="null"
                  selected
                  disabled
                >
                  {{ $t('string.chooseBorrowerStatus') }}
                </option>
                <template v-if="borrowerStatuses.length">
                  <option
                    v-for="(item, key) in borrowerStatuses"
                    :key="key"
                    :value="item.value"
                  >
                    {{ item['name_' + $i18n.locale] }}
                  </option>
                </template>
              </select>
              <span
                class="label-error"
                v-if="validations['borrower_status']"
              >
                {{ validations['borrower_status'][0] }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--employee information-->
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('labels.employeeInformation') }}
          </h3>
        </div>
        <div class="box-body">
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['occupation']}"
            >
              <label
                class="required"
                for="occupation"
              >{{ $t('fields.occupation') }}</label>
              <select
                class="form-control"
                id="occupation"
                :disabled="disabled"
                v-model="borrow.occupation"
              >
                <option
                  selected
                  disabled
                  :value="null"
                >
                  {{ $t('fields.occupation') }}
                </option>
                <option
                  v-for="(occupation, key) in occupations"
                  :key="key"
                  :value="occupation.value"
                >
                  {{ occupation.label }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations['occupation']"
              >
                {{ validations['occupation'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['company_name']}"
            >
              <label
                class="required"
                for="companyName"
              >{{ $t('fields.companyName') }}</label>
              <input
                type="text"
                :disabled="disabled"
                id="companyName"
                v-model="borrow.company_name"
                :placeholder="$t('fields.companyName')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['company_name']"
              >
                {{ validations['company_name'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['gross_monthly_income']}"
            >
              <label
                class="required"
                for="grossMonthlyIncome"
              >{{ $t('fields.grossMonthlyIncome') }}</label>
              <select
                v-model="borrow.gross_monthly_income"
                :disabled="disabled"
                id="grossMonthlyIncome"
                class="form-control"
              >
                <option
                  selected
                  disabled
                  :value="null"
                >
                  {{ $t('fields.grossMonthlyIncome') }}
                </option>
                <option
                  v-for="(income, key) in grossMonthlyIncomes"
                  :key="key"
                  :value="income.value"
                >
                  {{ income.label }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations['gross_monthly_income']"
              >
                {{ validations['gross_monthly_income'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['company_contact_name']}"
            >
              <label
                class="required"
                for="companyContactName"
              >{{ $t('fields.companyContactName') }}</label>
              <input
                type="text"
                :disabled="disabled"
                id="companyContactName"
                v-model="borrow.company_contact_name"
                :placeholder="$t('fields.companyContactName')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['company_contact_name']"
              >
                {{ validations['company_contact_name'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['company_contact_phone']}"
            >
              <label
                class="required"
                for="companyContactPhone"
              >{{ $t('fields.companyContactPhone') }}</label>
              <input
                type="text"
                :disabled="disabled"
                id="companyContactPhone"
                v-model="borrow.company_contact_phone"
                :placeholder="$t('fields.companyContactPhone')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['company_contact_phone']"
              >
                {{ validations['company_contact_phone'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['company_type']}"
            >
              <label
                class="required"
                for="companyType"
              >{{ $t('fields.companyType') }}</label>
              <select
                class="form-control"
                :disabled="disabled"
                id="companyType"
                v-model="borrow.company_type"
              >
                <option
                  selected
                  disabled
                  :value="null"
                >
                  {{ $t('fields.companyType') }}
                </option>
                <option
                  v-for="(companyType, key) in companyTypes"
                  :key="key"
                  :value="companyType.value"
                >
                  {{ companyType.label }}
                </option>
              </select>
              <span
                class="label-error"
                v-if="validations['company_type']"
              >
                {{ validations['company_type'][0] }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--relative information-->
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('labels.relativeInformation') }}
          </h3>
        </div>
        <div class="box-body">
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['relative_name']}"
            >
              <label
                class="required"
                for="relativeName"
              >{{ $t('fields.relativeName') }}</label>
              <input
                type="text"
                :disabled="disabled"
                id="relativeName"
                v-model="borrow.relative_name"
                :placeholder="$t('fields.relativeName')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['relative_name']"
              >
                {{ validations['relative_name'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['relative_contact_phone']}"
            >
              <label
                class="required"
                for="relativeContactPhone"
              >{{ $t('fields.relativeContactPhone') }}</label>
              <input
                type="text"
                id="relativeContactPhone"
                :disabled="disabled"
                v-model="borrow.relative_contact_phone"
                :placeholder="$t('fields.relativeContactPhone')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['relative_contact_phone']"
              >
                {{ validations['relative_contact_phone'][0] }}
              </span>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error': validations['relative_type']}"
            >
              <label
                class="required"
                for="relativeType"
              >{{ $t('fields.relativeType') }}</label>
              <select
                class="form-control"
                id="relativeType"
                :disabled="disabled"
                v-model="borrow.relative_type"
              >
                <option
                  selected
                  disabled
                  :value="null"
                >
                  {{ $t('fields.relativeType') }}
                </option>
                <option
                  v-for="(relative, relative_key) in relatives"
                  :key="relative_key"
                  :value="relative.value"
                >
                  {{ relative.label }}
                </option>
              </select>
              <template v-if="borrow.relative_type === 'Other'">
                <div class="margin-bottom" />
                <input
                  type="text"
                  :disabled="disabled"
                  class="form-control"
                  :placeholder="$t('label.relativeType')"
                  v-model="borrow.relative_type_other"
                >
              </template>
              <span
                class="label-error"
                v-if="validations['relative_type']"
              >
                {{ validations['relative_type'][0] }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--bank information-->
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('labels.bankInformation') }}
          </h3>
        </div>
        <div class="box-body">
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['bank_account_number']}"
            >
              <label
                class="required"
                for="bankAccountNumber"
              >{{ $t('fields.bankAccountNumber') }}</label>
              <input
                type="text"
                :disabled="disabled"
                id="bankAccountNumber"
                v-model="borrow.bank_account_number"
                :placeholder="$t('fields.bankAccountNumber')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['bank_account_number']"
              >
                {{ validations['bank_account_number'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['bank_name']}"
            >
              <label
                class="required"
                for="bankName"
              >{{ $t('fields.bankName') }}</label>
              <input
                type="text"
                id="bankName"
                :disabled="disabled"
                v-model="borrow.bank_name"
                :placeholder="$t('fields.bankName')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['bank_name']"
              >
                {{ validations['bank_name'][0] }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--social link-->
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            {{ $t('labels.socialNetwork') }}
          </h3>
        </div>
        <div class="box-body">
          <div class="form-group row">
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['facebook_name']}"
            >
              <label
                class="required"
                for="facebookName"
              >{{ $t('fields.facebookName') }}</label>
              <input
                type="text"
                id="facebookName"
                :disabled="disabled"
                v-model="borrow.facebook_name"
                :placeholder="$t('fields.facebookName')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['facebook_name']"
              >
                {{ validations['facebook_name'][0] }}
              </span>
            </div>
            <div
              class="col-md-6 form-group"
              :class="{'has-error' : validations['facebook_link']}"
            >
              <label
                class="required"
                for="facebookLink"
              >{{ $t('fields.facebookLink') }}</label>
              <input
                type="text"
                :disabled="disabled"
                id="facebookLink"
                v-model="borrow.facebook_link"
                :placeholder="$t('fields.facebookLink')"
                class="form-control"
              >
              <span
                class="label-error"
                v-if="validations['facebook_link']"
              >
                {{ validations['facebook_link'][0] }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--action panels-->
      <div class="row">
        <div class="col-md-12">
          <button
            v-if="editable"
            @click="onClickUpdate"
            class="btn btn-primary btn-sm btn-update margin-right-5"
          >
            {{ $t('buttons.update') }}
          </button>
          <button
            @click="onClickBack"
            class="btn btn-default btn-sm btn-back"
          >
            {{ $t('buttons.cancel') }}
          </button>
        </div>
      </div>
    </div>
    <change-borrow-type-modal />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import option from '../../includes/options'
import UploadPhoto from '../../includes/UploadPhoto'
import UploadNationalIdCard from '../../includes/UploadNationalIdCard'
import ChangeBorrowTypeModal from '@/views/borrows/_components/ChangeBorrowTypeModal'

export default {
  name: 'PersonalPayDayForm',
  components: {
    ChangeBorrowTypeModal,
    UploadNationalIdCard,
    UploadPhoto
  },
  mixins: [option],
  props: {
    editable: {
      type: Boolean,
      default: true
    },
    isClientForm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      borrow: {
        name: null,
        last_name: null,
        phone: null,
        email: null,
        national_id_number: null,
        gender: null,
        date_of_birth: null,
        marital_status: null,
        street_number: null,
        home_number: null,
        province: null,
        district: null,
        commune: null,
        how_long_have_been_living_there: null,
        borrow_education: null,
        school_name: null,
        graduate_year: null,
        source_of_information: null,
        membership: null,
        borrower_status: null,
        home_type: null,
        company_type: null,
        occupation: null,
        company_name: null,
        gross_monthly_income: null,
        company_contact_name: null,
        company_contact_phone: null,
        study_major: null,
        relative_name: null,
        relative_contact_phone: null,
        relative_type: null,
        bank_account_number: null,
        bank_name: null,
        facebook_name: null,
        facebook_link: null
      },
      validations: {},
      baseApi: process.env.VUE_APP_API,
      loanTypes: null,
      educations: null,
      disabled: false,
      memberships: [],
      loan: {
        amount: null,
        duration: null,
        loan_type: null,
        purpose_loan: null
      },
      borrowerStatuses: [],
      homeTypes: []
    }
  },
  computed: {
    ...mapState({
      provinces: state => state.location.provinces,
      districts: state => state.location.districts,
      communes: state => state.location.communes
    }),
    disabledInputLoanSection () {
      if (this.disabled) {
        return true
      } else {
        if (this.loan) {
          const statuses = ['Draft', 'Pending', 'Cancelled']
          return !(statuses.includes(this.loan.status))
        }
      }
      return false
    },
    apiUrl () {
      if (this.isClientForm) {
        return '/api/v4/backend/client/update'
      }
      return '/api/v1/borrows/update'
    },
    regionAPIUrl () {
      return 'https://geo-api.asorasoft.com/api/v1/region/options?api_key=ThIsIsKeYfOrCaShHeRo'
    }
  },
  watch: {
    '$i18n.locale' () {
      this.genders = [
        { label: this.$t('gender.male'), value: 'Male' },
        { label: this.$t('gender.female'), value: 'Female' }
      ]
    },
    'borrow.province' () {
      if (this.borrow && this.borrow.province) {
        this.getProvinces()
      }
    },
    'borrow.district' () {
      this.getDistricts()
    }
  },
  methods: {
    changeBorrowType () {
      this.$store.commit('changeBorrowType/SET_DATA', {
        id: this.$route.params.id || this.$route.params.borrow_id,
        type: this.borrow.type
      })
    },
    getBorrow () {
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/get-borrow', {
        id: this.$route.params.id || this.$route.params.borrow_id
      }).then(({ data }) => {
        if (data.data) {
          this.borrow = data.data
          const { loans } = data.data
          this.loan = loans && Array.isArray(loans) && loans.length > 0 ? loans[0] : null
        }
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.$isLoading(false)
      })
    },
    getBorrowEducations () {
      this.$axios.get(process.env.VUE_APP_API + '/api/v1/borrows/get-borrow-educations')
        .then(({ data }) => {
          if (data.data) {
            this.educations = data.data
          }
        })
    },
    getMemberships () {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/membership/get-option')
        .then(({ data }) => {
          if (data.data) {
            this.memberships = data.data
          }
        })
    },
    getHomeTypes () {
      this.$axios.get(process.env.VUE_APP_API + '/api/v1/home-types')
        .then(({ data }) => {
          this.homeTypes = data.data
        })
    },
    getBorrowerStatuses () {
      this.$axios.get(process.env.VUE_APP_API + '/api/v1/borrower-statuses')
        .then(({ data }) => {
          this.borrowerStatuses = data.data
        })
    },
    getLoanTypes () {
      this.$axios.get(process.env.VUE_APP_API + '/api/v1/loan/get-loan-types')
        .then(({ data }) => {
          if (data.data) {
            this.loanTypes = data.data
          }
        })
    },
    onClickBack () {
      this.$router.back()
    },
    onClickUpdate () {
      const self = this
      this.$swal({
        title: self.$t('string.updateBorrowInformation'),
        text: self.$t('string.doYouReallyWantToUpdateBorrowInformation?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesIWantIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          self.validations = {}
          self.$isLoading(true)

          // loan
          if (this.loan) {
            if (this.loan.purpose_loan) {
              this.borrow.loan_type = this.loan.purpose_loan
            }
            this.borrow.loan_uuid = this.loan.uuid
            this.borrow.amount = this.loan.amount
            this.borrow.type = this.loan.loan_type
            this.borrow.duration = this.loan.duration
          }

          if (this.borrow.relative_type !== 'Other') {
            this.borrow.relative_type_other = null
          }

          if (this.borrow.source_of_information !== 'Other') {
            this.borrow.source_of_information_other = null
          }

          self.$axios.post(process.env.VUE_APP_API + this.apiUrl, self.borrow)
            .then((response) => {
              self.$isLoading(false)
              if (response.data.code === 1) {
                self.$toastr(
                  'success',
                  self.$t('string.theApplicantFormIsUpdatedSuccessfully'),
                  self.$t('string.updateApplicantForm')
                )
                self.$router.back()
              }
              if (response.data.code === 0) {
                if (response.data.message.length > 0) {
                  const messages = response.data.message
                  let html = ''
                  try {
                    html = '<ul>'
                    messages.forEach((message) => {
                      html += '<li>' + message + '</li>'
                    })
                    html += '</ul>'
                  } catch (e) {
                    html = messages
                  }
                  self.$toastr('warning', html, 'Loandisk Integration')
                } else {
                  self.validations = response.data.message
                  self.$swal({
                    title: self.$t('string.verifyRequiredFields'),
                    text: self.$t('string.pleaseFillAllFieldsAreRequired'),
                    type: 'warning',
                    confirmButtonText: self.$t('button.ok')
                  })
                }
              }
            })
            .catch((error) => {
              this.onResponseError(error)
            })
            .finally(() => {
              this.$isLoading(false)
            })
        }
      }).catch((error) => {
        this.onResponseError(error)
      })
    },
    getProvinces () {
      this.$axios.get(`${this.regionAPIUrl}&level=1&selects=name_km,name_latin,code`)
        .then(({ data }) => {
          if (data.data) {
            const provinces = data.data
            this.$store.commit('location/setProvincesOption', provinces)
            const province = this.provinces.find((item) => {
              const { name_latin } = item
              return name_latin === this.borrow.province || item.name_km === this.borrow.province
            })
            if (province) {
              const { name_latin } = province
              this.borrow.province = name_latin
              this.$store.commit('location/setProvince', province)
            } else {
              this.borrow.province = null
              this.$store.commit('location/setProvince', null)
            }
          }
        }).finally(() => {
          this.getDistricts()
        })
    },
    getDistricts () {
      const province = this.$store.state.location.province
      if (province === null) {
        return 0
      }
      this.$axios.get(`${this.regionAPIUrl}&code=${province.code}&selects=name_km,name_latin,code`)
        .then(({ data }) => {
          if (data.data) {
            const districts = data.data
            this.$store.commit('location/setDistrictsOption', districts)
            const district = this.districts.find((item) => {
              const { name_latin } = item
              return name_latin === this.borrow.district || item.name_km === this.borrow.district
            })

            if (district) {
              const { name_latin } = district
              this.borrow.district = name_latin
              this.$store.commit('location/setDistrict', district)
            } else {
              this.borrow.distirct = null
              this.$store.commit('location/setDistrict', null)
            }
          }
        }).finally(() => {
          this.getCommunes()
        })
    },
    getCommunes () {
      const district = this.$store.state.location.district
      if (district === null) {
        return 0
      }
      this.$axios.get(`${this.regionAPIUrl}&code=${district.code}&selects=name_km,name_latin,code`)
        .then(({ data }) => {
          if (data.data) {
            const communes = data.data
            this.$store.commit('location/setCommunesOption', communes)
            const commune = this.communes.find((item) => {
              const { name_latin } = item
              return name_latin === this.borrow.commune || item.name_km === this.borrow.commune
            })
            if (commune) {
              const { name_latin } = commune
              this.borrow.commune = name_latin
              this.$store.commit('location/setCommune', commune)
            } else {
              this.borrow.commue = null
              this.$store.commit('location/setCommune', null)
            }
          }
        })
    }
  },
  mounted () {
    if (this.$route.name === 'show-applicant') {
      this.disabled = true
    }

    this.$nextTick(() => {
      this.getProvinces()
      this.getBorrow()
      this.getLoanTypes()
      this.getBorrowEducations()
      this.getMemberships()
      this.getHomeTypes()
      this.getBorrowerStatuses()
    })
  }
}
</script>

<style scoped></style>
